module.exports = __webpack_public_path__ + "img/aleop-v2.9eebebae.webp";